var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-239.706,-244.009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.2,244.009L240.175,244.009C239.918,244.009 239.707,244.22 239.707,244.477L239.707,250.5C239.707,250.757 239.918,250.968 240.175,250.969L242.719,250.969L242.719,255.019C242.719,255.276 242.931,255.488 243.188,255.488L244.694,255.488C244.895,255.488 245.075,255.358 245.139,255.167L246.645,250.648C246.661,250.6 246.669,250.55 246.669,250.5L246.669,244.475C246.667,244.219 246.456,244.009 246.2,244.009ZM245.731,250.427L244.356,254.553L243.656,254.553L243.656,250.5C243.656,250.243 243.444,250.031 243.187,250.031L240.643,250.031L240.643,244.943L245.731,244.943L245.731,250.427Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9.37,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.607,244.009L258.582,244.009C258.325,244.009 258.114,244.22 258.113,244.477L258.113,250.5C258.113,250.757 258.325,250.969 258.582,250.969L261.126,250.969L261.126,255.019C261.126,255.276 261.338,255.488 261.595,255.488L263.1,255.488C263.301,255.488 263.481,255.358 263.544,255.167L265.05,250.648C265.066,250.6 265.074,250.55 265.074,250.5L265.074,244.475C265.073,244.219 264.863,244.01 264.607,244.009ZM264.138,250.427L262.762,254.553L262.062,254.553L262.062,250.5C262.062,250.243 261.85,250.031 261.593,250.031L259.049,250.031L259.049,244.943L264.137,244.943L264.138,250.427Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.60776015.svg";
export { ForwardRef as ReactComponent };